import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

import { theme, DesignSystemGlobals } from '@kueski-dev/kueski-design-system';

interface DesignSystemProviderProps {
  children: ReactNode;
}

export default function DesignSystemProvider({ children }: DesignSystemProviderProps) {
  return (
    <ThemeProvider theme={theme}>
      <DesignSystemGlobals />
      {children}
    </ThemeProvider>
  );
}
